import { FaEye, FaRegEdit, FaTrashAlt, FaPlus } from "react-icons/fa";
import Pagination from '@mui/material/Pagination';
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import ButtonIcon from "components/ButtonIcon";
import TableComponent from "components/Table";
import { NewsWrapper } from "./styled"
import { newsSelector, newsCategoriesSelector } from 'redux/selector'
import { newsActions } from 'redux/slice/newsSlice'
import { newsCategoriesActions } from 'redux/slice/newsCategoriesSlice'
import AdminLoading from "components/AdminLoading";
import Modal from "./Modal";
import FormSearch from "components/FormSearch";
import useDebounce from 'hooks/useDebounce'
import Loading from "components/Loading";

const News = () => {
    document.title = 'Quản lý bài viết'
    const location = useLocation()
    const query = new URLSearchParams(location.search)
    const qPage = query.get("page")
    const navigate = useNavigate()

    const [showModal, setShowModal] = useState(false)
    const [currentPage, setCurrentPage] = useState(qPage ? parseInt(qPage) : 1)
    const newsState = useSelector(newsSelector)
    const newsCategoriesState = useSelector(newsCategoriesSelector)
    const dispatch = useDispatch()
    const [method, setMethod] = useState('add')
    const [selectedId, setSelectedId] = useState(null)
    const [totalItemInPage, setTotalItemInPage] = useState(0)
    const [category, setCategory] = useState('all')
    const [queryInput, setQueryInput] = useState('')
    const querySearch = useDebounce(queryInput, 500)

    useEffect(() => {
        dispatch(newsCategoriesActions.getNewsCategoriesAll())
    }, [dispatch])

    useEffect(() => {
        dispatch(newsActions.getNews({ query: querySearch, category, currentPage }))
    }, [category, currentPage, dispatch, querySearch])

    const handleChangeCategory = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/news?page=1`)
        }
        setCategory(e.target.value)
    }
    const handleChangeSearchInput = (e) => {
        if (currentPage > 1) {
            setCurrentPage(1)
            navigate(`/admin/news?page=1`)
        }
        setQueryInput(e.target.value)
    }
    const handleChangePaginate = (event, pageNumber) => {
        setCurrentPage(pageNumber)
        navigate(`/admin/news?page=${pageNumber}`)
    }

    const handleHiddenForm = () => {
        setSelectedId(null)
        setShowModal(!showModal)
    }

    const handleShowAddModal = () => {
        setMethod('add')
        setShowModal(!showModal)
    }
    const handleShowDetailModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('show')
        setShowModal(!showModal)
    }

    const handleShowUpdateModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('update')
        setShowModal(!showModal)
    }

    const handleShowRemoveModal = (selectedId) => {
        setSelectedId(selectedId)
        setMethod('remove')
        setShowModal(!showModal)
    }

    const columns = [
        {
            title: 'Mã bài viết',
            dataIndex: 'news_id',
            key: 'news_id',
            align: "center"
        },
        {
            title: 'Tên bài viết',
            dataIndex: 'news_title',
            key: 'news_title',
            align: "center"
        },
        {
            title: 'Thể loại',
            dataIndex: 'name',
            key: 'name',
            align: "center"
        },
        {
            title: 'Người thêm',
            dataIndex: 'account_name',
            key: 'account_name',
            align: "center"
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'created_at',
            key: 'created_at',
            align: "center"
        },
        {
            title: 'Thao tác',
            key: 'action',
            align: 'center',
            render: (_, { news_id }) => (
                <>
                    {/* <ButtonIcon
                        onClick={() => handleShowDetailModal(news_id)}
                        icon={<FaEye />}
                        description='Chi tiết'
                        classButton="action-primary btn-action"
                    /> */}
                    <ButtonIcon
                        onClick={() => handleShowUpdateModal(news_id)}
                        icon={<FaRegEdit />}
                        description='Sửa'
                        classButton="action-danger-2 btn-action"
                    />
                    <ButtonIcon
                        onClick={() => handleShowRemoveModal(news_id)}
                        icon={<FaTrashAlt />}
                        description='Xóa'
                        classButton="action-danger btn-action"

                    />
                </>
            ),
        },
    ];

    useMemo(() => {
        if (currentPage > 1) {
            setTotalItemInPage((currentPage - 1) * 5 + newsState.newsList.length)
        }
        else {
            setTotalItemInPage(newsState.newsList.length)
        }
    }, [currentPage, newsState.newsList.length])

    return (
        <NewsWrapper className="admin_news">
            <div className="admin_news_control py-0 px-15">
                <div className="admin_news_control py-0 px-15">
                    {/* <FormSearch
                        placeholder='Tìm kiếm bài viết...'
                        queryInput={queryInput}
                        onChange={handleChangeSearchInput}
                        setQueryInput={setQueryInput}
                    /> */}

                </div>
                <div className="admin_news_control_sort-add">
                    <div className="admin_news_control_sort-add">
                        <select className="mr-15 px-10" onChange={handleChangeCategory}>
                            <option value='all'>Toàn bộ</option>
                            {
                                newsCategoriesState?.newsCategoriesListAll?.map((item, index) => (
                                    <option value={item.id} key={index}>{item.name}</option>
                                ))
                            }
                        </select>
                    </div>
                    <ButtonIcon
                        onClick={handleShowAddModal}
                        icon={<FaPlus />}
                        description="Thêm mới"
                        classButton="btn_add action-danger-1"
                    />
                </div>
            </div>
            <div className="admin_news_table">

                {
                    newsState.isFetching &&
                    < Loading />
                }
                <TableComponent
                    columns={columns}
                    data={newsState?.newsList}
                />
            </div>
            {
                newsState?.newsList?.length > 0 &&
                <div className="admin_news_pagination mt-15 px-15">
                    <span className="admin_news_pagination_total_item medium">
                        {totalItemInPage} / {newsState.totalItem}
                    </span>
                    {
                        newsState.totalPage > 1 &&
                        <Pagination count={newsState.totalPage} color="primary"
                            onChange={(event, pageNumber) => handleChangePaginate(event, pageNumber)}
                            page={currentPage}
                        />
                    }
                </div>
            }
            <Modal
                selectedId={selectedId}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataNewsCategory={newsCategoriesState.newsCategoriesListAll}
                selectedCategory={category}
                showModal={showModal}
                hidden={handleHiddenForm}
                method={method}
                querySearch={querySearch}
            />
        </NewsWrapper>
    );
}

export default News;